const ContactUs = () => {
  return (
    <div className="text-color page-copy">
      <h4 className="mb-3">Contáctanos</h4>
      <b>
      En TUBID, valoramos tus comentarios, preguntas y consultas. Ya sea que necesites ayuda con una subasta, tengas una sugerencia o simplemente quieras comunicarte con nosotros, nuestro equipo está aquí para ayudarte. No dudes en contactarnos a través del formulario de contacto, correo electrónico o número de teléfono proporcionado, y te responderemos de manera rápida para asegurarnos de que tu experiencia con nosotros sea excepcional. Tu satisfacción es nuestra prioridad, y esperamos con gusto saber de ti.
      </b>
    </div>
  );
};

export default ContactUs;
